import { createTranslationResource } from '@backstage/frontend-plugin-api';
import { scaffolderReactTranslationRef } from '@backstage/plugin-scaffolder-react';

export const scaffolderReactTranslations = createTranslationResource({
  ref: scaffolderReactTranslationRef,
  translations: {
    'pt-BR': () => import('./pt-BR'),
  },
});
